import logo from './logo.svg';
import './App.css';
import "./i18n";
import Home from './pages/Home.js';
import About from './pages/About.js';
import Login from './pages/Login.js';
import Dashboard from './pages/Dashboard.js';
import Registration from './pages/Registration.js';
import Profile from './pages/Profile.js';
import PaymentHistory from './pages/PaymentHistory.js';
import CodeCredit from './pages/CodeCredit.js';
import DomainRegistration from './pages/DomainRegistration.js';
import CustomerSupport from './pages/CustomerSupport.js';
import Success from './pages/Success.js';
import Success2 from './pages/Success2.js';
import Success3 from './pages/Success3.js';
import EditWebsite from './pages/EditWebsite.js';
import Credit from './pages/Credit.js';
import Store from './pages/Store.js';
import Admin from './pages/Admin.js';


import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import { BrowserRouter,Routes, Route, Link,useNavigate } from "react-router-dom";
import eruda from "eruda";
import React, { useState, useEffect,useRef } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";










function App() {
	
	
	
	const navigate = useNavigate();
	
	
	
	useEffect(()=>{
		
		
	if(window.innerWidth<768){
   //  eruda.init();
	}	
	
	if(!localStorage.getItem('i18nextLng')){
	  if(navigator.language.startsWith("en")){
       i18n.changeLanguage("en");
      }	 
 
      else if(navigator.language.startsWith("fr")){
	  i18n.changeLanguage("fr"); 
      }
 
     else{
	i18n.changeLanguage("en") ; 
     }
	} 

  
		
	},[]);
	
  return (
   <div>

	  
	  
	  
	  

      <Routes>
	  <Route path="/" element={<Login />} />
        <Route path="/ai-wizard" element={<Home/>} />
        <Route path="/about" element={<About />} />
		<Route path="/edit-website/:folderName" element={<EditWebsite />} />
		<Route path="/store/:folderName" element={<Store />} />
		<Route path="/login" element={<Login />} />
		<Route path="/registration" element={<Registration />} />
		<Route path="/Profile" element={<Profile />} />
		<Route path="/Dashboard" element={<Dashboard />} />
		<Route path="/Payment-history" element={<PaymentHistory />} />
		<Route path="/credit-code" element={<CodeCredit />} />
		<Route path="/domain-registration" element={<DomainRegistration />} />
		<Route path="/credit-code" element={<CodeCredit />} />
		<Route path="/customer-support" element={<CustomerSupport />} />
		<Route path="/success" element={<Success />} />
		<Route path="/success-credit" element={<Success2 />} />
		<Route path="/success-domain" element={<Success3 />} />
		<Route path="/credit" element={<Credit />} />
		<Route path="/admin" element={<Admin />} />
      </Routes>
	
    </div>
  );
}

export default App;
